/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum FuelStatsGroupByTimespan {
    Day = 'day',
    Month = 'month',
    Week = 'week'
}

export function FuelStatsGroupByTimespanFromJSON(json: any): FuelStatsGroupByTimespan {
    return FuelStatsGroupByTimespanFromJSONTyped(json, false);
}

export function FuelStatsGroupByTimespanFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelStatsGroupByTimespan {
    return json as FuelStatsGroupByTimespan;
}

export function FuelStatsGroupByTimespanToJSON(value?: FuelStatsGroupByTimespan | null): any {
    return value as any;
}

